import { Fase, FaseJSON } from '../Fase/Fase';
export interface TorneoZonaXFaseJSON {
  tzxf_id: string;
  tzxf_faseid: string;
  tzxf_nombre_zona: string;
  fase: FaseJSON | null;
}

export class TorneoZonaXFase {
  protected constructor(
    private id: string,
    private faseid: string,
    private nombreZona: string,
    private fase: Fase | null
  ) {}

  static createFrom(id: string, faseid: string, nombreZona: string, fase: Fase | null) {
    return new this(id, faseid, nombreZona, fase);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: TorneoZonaXFase) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TorneoZonaXFaseJSON) {
    return TorneoZonaXFase.createFrom(
      entity.tzxf_id,
      entity.tzxf_faseid,
      entity.tzxf_nombre_zona,
      entity.fase ? Fase.fromJSON(entity.fase!) : null
    );
  }

  toJSON(): TorneoZonaXFaseJSON {
    return {
      tzxf_id: this.getId(),
      tzxf_faseid: this.getFaseid(),
      tzxf_nombre_zona: this.getNombreZona(),
      fase: this.getFase() ? this.getFase()!.toJSON() : null,
    };
  }

  getId(): string {
    return this.id;
  }

  getFaseid(): string {
    return this.faseid;
  }

  getNombreZona(): string {
    return this.nombreZona;
  }

  setNombreZona(v: string) {
    this.nombreZona = v;
  }

  getFase(): Fase | null {
    return this.fase;
  }
}
